import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '@/views/public/LoginView'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    // Handle login stage and pre-filled credentials from URL params
    beforeEnter: (to, from, next) => {
      if (to.query.stage) {
        store.dispatch('setStage', to.query.stage)
      }

      if (to.query.login_hint) {
        store.dispatch('setLoginHint', to.query.login_hint)
      }
      next()
    },
  },
  {
    path: '/reset',
    name: 'resetRequest',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "resetRequest" */ '../views/public/ResetRequestView.vue'
      ),
  },
  {
    path: '/reset/:token',
    name: 'reset',
    component: () =>
      import(/* webpackChunkName: "reset" */ '../views/public/ResetView.vue'),
  },
  {
    path: '/error',
    name: 'error',
    component: () =>
      import(/* webpackChunkName: "reset" */ '../views/public/ErrorView.vue'),
  },
  {
    path: '/saml/redirect',
    name: 'samlRedirect',
    component: () =>
      import(
        /* webpackChunkName: "reset" */ '../views/public/SAMLRedirect.vue'
      ),
  },
  {
    path: '/logged-out',
    name: 'logged-out',
    component: () =>
      import(
        /* webpackChunkName: "logged-out" */ '../views/public/LogoutView.vue'
      ),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
